/** Auth + the generic KORM door, shared by every surface. */
const stripModel = ({ model, ...rest }) => rest;

export default {
  context: () => ({ url: '/api/meta/context', method: 'GET' }),
  // Product types and their spec fields + inspection checklists (D32, lib/catalog/productTypes).
  productTypes: () => ({ url: '/api/meta/product-types', method: 'GET' }),

  login: (data) => ({ url: '/api/crud/User', method: 'POST', data: { action: 'login', data } }),
  logout: () => ({ url: '/api/crud/User', method: 'POST', data: { action: 'logout' } }),

  // Generic: fetchApi('crud', { model:'InventoryUnit', action:'list', where:{...}, data:{...} })
  crud: (body) => ({ url: `/api/crud/${body.model}`, method: 'POST', data: stripModel(body) }),
};
